module.exports = __webpack_public_path__ + "img/logo.1194f984.svg";